import { render, staticRenderFns } from "./ItemExaminationsPerDay.vue?vue&type=template&id=2c126e45&"
import script from "./ItemExaminationsPerDay.vue?vue&type=script&lang=js&"
export * from "./ItemExaminationsPerDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports